const PERCENT_DIVISOR = 100;

/**
 * Open fee as a share of the wager, 0 until the pair comes from the backend list.
 * @param {{ open_fee_percent?: number }} [pair]
 * @returns {number}
 */
export const getOpenFeeRate = (pair) =>
  (Number(pair?.open_fee_percent) || 0) / PERCENT_DIVISOR;
